import {useEffect, useState} from "react";
import axios from "axios";
import Helpers from "../Helpers";

export default function useStash(token, member) {
  const {handleError, isNotEmpty} = Helpers();
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isNotEmpty(token) && (member.hasMP || member.hasRV)) {
      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        url: `${process.env.REACT_APP_API}/stash`,
      }).then(res => {
        setItems(res.data);
        setReady(true);
      }).catch(err => {
        setReady(true);
        handleError(err);
      });
    }
  }, [token, member]);

  function add(data, cb) {
    axios({
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      url: `${process.env.REACT_APP_API}/stash`,
      data: data,
    }).then(res => {
      setItems(res.data);
      if (cb) cb(true);
    }).catch(() => {
      // do nothing
      if (cb) cb(false);
    });
  }

  function update(data, cb) {
    axios({
      method: "put",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      url: `${process.env.REACT_APP_API}/stash/${data.id}`,
      data: data,
    }).then(res => {
      setItems(res.data);
      if (cb) cb(true);
    }).catch(() => {
      // do nothing
      if (cb) cb(false);
    });
  }

  function toggleLove(data, cb) {
    const item = items.find(i => i.documentId === data.documentId && i.documentType === data.documentType);
    const before = {
      pinned: item === undefined ? false : item.pinned,
      saved: item === undefined ? false : item.saved,
      loved: item === undefined ? false : item.loved,
    };
    let payload;
    if (item === undefined) {
      payload = {...data, pinned: false, loved: true, saved: false};
      add(payload, updated => {
        if (cb) cb({
          updated: updated,
          documentId: data.documentId,
          documentType: data.documentType,
          before: before,
          after: { pinned: payload.pinned, saved: payload.saved, loved: payload.loved },
        });
      });
    } else {
      payload = {...data, id: item.id, pinned: item.pinned, loved: !item.loved, saved: item.saved};
      update(payload, updated => {
        if (cb) cb({
          updated: updated,
          documentId: data.documentId,
          documentType: data.documentType,
          before: before,
          after: { pinned: payload.pinned, saved: payload.saved, loved: payload.loved },
        });
      });
    }
  }

  function togglePin(data, cb) {
    const item = items.find(i => i.documentId === data.documentId && i.documentType === data.documentType);
    const before = {
      pinned: item === undefined ? false : item.pinned,
      saved: item === undefined ? false : item.saved,
      loved: item === undefined ? false : item.loved,
    };
    let payload;
    if (item === undefined) {
      payload = {...data, pinned: true, loved: false, saved: false};
      add(payload, updated => {
        if (cb) cb({
          updated: updated,
          documentId: data.documentId,
          documentType: data.documentType,
          before: before,
          after: { pinned: payload.pinned, saved: payload.saved, loved: payload.loved },
        });
      });
    } else {
      payload = {...data, id: item.id, loved: item.loved, pinned: !item.pinned, saved: item.saved};
      update(payload, updated => {
        if (cb) cb({
          updated: updated,
          documentId: data.documentId,
          documentType: data.documentType,
          before: before,
          after: { pinned: payload.pinned, saved: payload.saved, loved: payload.loved },
        });
      });
    }
  }

  function toggleSaved(data, cb) {
    const item = items.find(i => i.documentId === data.documentId && i.documentType === data.documentType);
    const before = {
      pinned: item === undefined ? false : item.pinned,
      saved: item === undefined ? false : item.saved,
      loved: item === undefined ? false : item.loved,
    };
    let payload;
    if (item === undefined) {
      payload = {...data, pinned: false, loved: false, saved: true};
      add(payload, updated => {
        if (cb) cb({
          updated: updated,
          documentId: data.documentId,
          documentType: data.documentType,
          before: before,
          after: { pinned: payload.pinned, saved: payload.saved, loved: payload.loved },
        });
      });
    } else {
      payload = {...data, id: item.id, loved: item.loved, pinned: item.pinned, saved: !item.saved};
      update(payload, updated => {
        if (cb) cb({
          updated: updated,
          documentId: data.documentId,
          documentType: data.documentType,
          before: before,
          after: { pinned: payload.pinned, saved: payload.saved, loved: payload.loved },
        });
      });
    }
  }

  function filterItems(terms) {
    if (isNotEmpty(terms)) {
      setFilteredItems(items.filter(i => i.title.toLowerCase().indexOf(terms.toLowerCase()) !== -1));
    } else {
      setFilteredItems(items);
    }
  }

  const stashStore = {
    items: items,
    filteredItems: filteredItems,
    ready: ready,
    add: add,
    update: update,
    toggleLove: toggleLove,
    togglePin: togglePin,
    toggleSaved: toggleSaved,
    filterItems: filterItems,
  }

  return {stashStore};
}
